<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Comparaison des infos patients </div>
        <div class="modal-body">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>Patient connu</th>
                        <th>Patient document</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="label">Nom de naissance</td>
                        <td class="infos-patient" *ngIf="hmPatient">{{ hmPatient.nomNaissance }}</td>
                        <td class="infos-patient" *ngIf="cdaPatient">{{ cdaPatient.nomNaissance }}</td>
                    </tr>
                    <tr>
                        <td class="label">Prénom de naissance</td>
                        <td class="infos-patient" *ngIf="hmPatient">{{ hmPatient.prenomNaissance }}</td>
                        <td class="infos-patient" *ngIf="cdaPatient">{{ cdaPatient.prenomNaissance }}</td>
                    </tr>
                    <tr>
                        <td class="label">Date de naissance</td>
                        <td class="infos-patient" *ngIf="hmPatient">{{ hmPatient.dateNaissance }}</td>
                        <td class="infos-patient" *ngIf="cdaPatient">{{ cdaPatient.dateNaissance }}</td>
                    </tr>
                    <tr>
                        <td class="label">Sexe</td>
                        <td class="infos-patient" *ngIf="hmPatient">{{ hmPatient.sexe }}</td>
                        <td class="infos-patient" *ngIf="cdaPatient">{{ cdaPatient.sexe }}</td>
                    </tr>
                    <tr>
                        <td class="label">INS</td>
                        <td class="infos-patient" *ngIf="hmPatient">{{ hmPatient.ins }}</td>
                        <td class="infos-patient" *ngIf="cdaPatient">{{ cdaPatient.ins }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="buttons-wrapper">
                <frg-button
                    (activated)="closeModal()"
                    backgroundColor="var(--orange)"
                >Le patient du document n'est PAS mon patient</frg-button>

                <frg-button
                    (activated)="closeModal(true)"
                >Le patient du document est bien mon patient</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>